module.exports = __webpack_public_path__ + "static/img/28.c0aac239.png";